module.exports = __webpack_public_path__ + "static/media/left-right.ce338fee.mp3";